<template>
  <div>
    <CategoriesForm :categories="categories" :mobile-ajax-categories-path="mobileAjaxCategoriesPath" :business-id="businessId" />
    <WebhookForm
      :webhook-url="webhookUrl"
      :webhook-bearer-token="webhookBearerToken"
      :zapier-webhook-url="zapierWebhookUrl"
      :mobile-business-path="mobileBusinessPath" />
    <SubscriptionForm
      :subscription-cancelled="subscriptionCancelled"
      :free-subscription="freeSubscription"
      :free-subscription-available="freeSubscriptionAvailable"
      :mobile-business-path="mobileBusinessPath" />

    <h2 class="h3 m-0 mb-2 font-weight-semi-bold text-dark">Public token</h2>
    <div class="narrow-form pt-1 mb-5">
      <div class="mv-token-field">
        {{ publicToken }}
        <i class="btn btn-link far fa-copy" @click="copyPublicToken(publicToken)" />
      </div>
    </div>

    <h2 class="h3 m-0 mb-2 font-weight-semi-bold text-dark">GeoBooster widget</h2>
    <p class="pt-1 mb-3 narrow-form wide">
      Embed our <a :href="appHelpLink" target="_blank">JavaScript widget</a> into your non-WordPress website.
    </p>
    <div class="narrow-form pt-1 mb-5">
      <code class="mv-widget-code">
        <pre ref="code">
&lt;script id="geobooster_widget_script" type="module"
  src="{{ gbWidgetUrl }}"
  data-google-api-key="Setup your Google key here"
  data-business-token="{{ publicToken }}"&gt;
&lt;/script&gt;
        </pre>
        <i class="btn btn-link far fa-copy" aria-hidden="true" @click="copyWidgetCode" />
      </code>
    </div>

    <!-- TODO when api will be ready -->
    <!-- <button type="button" class="btn btn-sm rounded">Disconnect business</button> -->
  </div>
</template>

<script>
import CategoriesForm from './settings/categories_form'
import WebhookForm from './settings/webhook_form'
import SubscriptionForm from './settings/subscription_form'
import copyToClipboard from '../../../common/copy_to_clipboard'

export default {
  components: { CategoriesForm, WebhookForm, SubscriptionForm },
  props: {
    categories: { type: Array, required: true },
    webhookUrl: { type: String, default: '' },
    webhookBearerToken: { type: String, default: '' },
    zapierWebhookUrl: { type: String, default: '' },
    publicToken: { type: String, default: '' },
    mobileBusinessPath: { type: String, default: '' },
    mobileAjaxCategoriesPath: { type: String, default: '' },
    businessId: { type: String, required: true },
    subscriptionCancelled: { type: Boolean, default: false },
    freeSubscription: { type: Boolean, default: false },
    freeSubscriptionAvailable: { type: Boolean, default: false },
    gbWidgetUrl: { type: String, required: true }
  },
  computed: {
    appHelpLink() {
      return Styxie.WLC.appCodename === 'lv' ?
        'https://help.localviking.com/en/articles/4758104-geobooster-js-widget' :
        'https://help.localbrandmanager.com/en/articles/6797699-geobooster-js-widget'
    }
  },
  methods: {
    copyPublicToken(token) {
      new Promise((resolve) => { // eslint-disable-line consistent-return
        copyToClipboard(token)
        return resolve()
      }).then(() => {
        toastr.success('Public token was copied to clipboard')
      })
    },
    copyWidgetCode() {
      new Promise((resolve) => { // eslint-disable-line consistent-return
        copyToClipboard(this.$refs.code.innerText)
        return resolve()
      }).then(() => {
        toastr.success('GeoBooster widget code was copied to clipboard')
      })
    }
  }
}
</script>
